import React from "react";
import {
	Box,
	Typography,
	ToggleButton,
	ToggleButtonGroup
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import getTrans from "../../../../../languages/getTrans";

const FilterType = (props) => {
	const {
		filter,
		onChange
	} = props;
	const classes = useStyles();

	const handleChangeType = (event, value) => {
		if (filter.type === value || !value) {
			return
		}
		let _filter = {...filter};
		_filter.type = value;
		_filter.page = 1;
		onChange(_filter);
	}

	return (
		<Box className={classes.root}>
			<div className={classes.section}>
				<ToggleButtonGroup
					color="primary"
					value={filter.type}
					exclusive
					className={classes.buttonsGroup}
					onChange={handleChangeType}
				>
					<ToggleButton value="incoming">{getTrans('history.Пополнения')}</ToggleButton>
					<ToggleButton value="outgoing">{getTrans('history.Расходы')}</ToggleButton>
				</ToggleButtonGroup>
			</div>
		</Box>
	)
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		marginTop: "6px",
		marginBottom: "8px",
		justifyContent: "flex-start",
	},
	section: {
		padding: "4px",
		borderRadius: "8px",
		boxSizing: "border-box",
		background: "#FFFFFF1A",
		border: "1px solid #FFFFFF33",
	},
	buttonsGroup: {
		"& .MuiButtonBase-root": {
			height: 32,
			border: "none",
			padding: "0 12px",
			borderRadius: "6px",
			boxSizing: "border-box",

			fontSize: 15,
			color: "white",
			fontWeight: "500",
			lineHeight: "18px",
			textTransform: "initial",

			"&.Mui-selected": {
				backgroundColor: "#FB7800!important",
				color: "white",
			}
		}
	}
}));

export default FilterType
